<template>
<div class="chat-login-container">
    <div class="chat-login-tips">
        <!-- <p class="chat-login-tips-title">Halo</p> -->
        <p class="chat-login-tips-pargraph">
            If you have any questions or need assistance with getting a quote or placing an online order, we're here to help.<br>
            Simply fill in your name and email address to start chatting with our helpful and experienced agents!
        </p>
    </div>
    <div class="chat-login-ipts">
        <input :readonly="uneditble" :class="uneditble ? 'chat-app-readonly' : ''" type="text" ref="loginName" v-model="name" placeholder="name">
        <input :readonly="uneditble" :class="uneditble ? 'chat-app-readonly' : ''" type="text" v-model="email" placeholder="email address">
        <div v-show="error_name" class="err-tip-text">Please enter a valid name</div>
        <div v-show="error_email" class="err-tip-text">Please enter a valid email address</div>
    </div>
    <div class="chat-login-btns">
        <a @click="ping" href="javascript:;" class="register-chat-btn">
            <div v-if="loading" class="mask-prevent"><img src="../assets/loading-process.svg" alt=""></div>
            Start Chat!
        </a>
    </div>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

const mailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,9}$/


export default {
    data() {
        return {
            name: '',
            email: '',
            loading: false,
            error_name: false,
            error_email: false,
            uneditble: false,
        }
    },
    computed: {
        ...mapState(['user', 'tip_object'])
    },
    mounted() {
        if (window.WINDOW_USER_INFO) {
            this.uneditble = true
            this.name = window.WINDOW_USER_INFO.firstname + ' ' + window.WINDOW_USER_INFO.lastname
            if (!this.name.trim().length) this.name = window.WINDOW_USER_INFO.login.split('@')[0]
            this.email = window.WINDOW_USER_INFO.login
        } else {
            this.$refs.loginName.focus()
        }
    },
    methods: {
        ...mapMutations(['updateUser']),
        ...mapActions(['init']),
        ping() {
            if (!this.name.trim().length) {
                this.error_name = true
                return
            } else {
                this.error_name = false
            }
            if (!mailReg.test(this.email)) {
                this.error_email = true
                return
            } else {
                this.error_email = false
            }

            if (this.loading) return
            this.loading = true
            
            this.updateUser({ name: this.name, email: this.email })
            this.$remote.$emit('ping', Object.assign(this.user, { user_id: window.WINDOW_USER_INFO ? window.WINDOW_USER_INFO.user_id : null }))
        }
    }
}
</script>


<style lang="scss" scoped>
.chat-login-container { position: absolute; top: 75px; left: 0; right: 0; bottom: 0; margin: 30px 35px 40px; font-size: 14px; 
    padding: 25px 25px 10px; border: 1px solid #e6ebef; border-radius: 4px; 
    .chat-login-tips { position: relative; background-color: #fff; margin-bottom: 30px;
        font-size: 13px; line-height: 1.5; width: 100%;
        &-title { font-size: 20px; line-height: 1.33; margin: 0 0 10px; color:#286efa; font-weight: 400;}
        &-pargraph {font-size: 14px; line-height: 1.4; margin: 0 0 10px; color:#6e7a89; text-align: left;}
    }
    .chat-login-ipts { text-align: left;
        input {width: 100%; border: 1px solid #e6ebef; border-radius: 4px; height: 42px; background: #fff; outline: none; margin-bottom: 15px;
            padding: 0 20px;
            &.chat-app-readonly {background: #f2f2f2; cursor: not-allowed;}
        }
        .err-tip-text {color:#f40; font-size: 13px;}
    }
    .chat-login-btns { position: absolute; bottom: 30px; left: 0; width: 100%;
        .register-chat-btn { display: inline-block; color: #fff; background-color: #286efa; text-align: center; transition: all .2s ease-in-out;
            border-radius: 4px; padding: 8px 40px; font-size: 14px; text-decoration: none; margin: 0; line-height: 1.4; position: relative; overflow: hidden;
            &:hover { box-shadow: 0 8px 24px rgba(0,0,0,.2);}
        }
        .mask-prevent {position: absolute; left: 0; top: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, .25);
            img, svg { width: 100%; height: 100%; transform: scale(.75); 
                animation: cyc 2s infinite cubic-bezier(0.645, 0.045, 0.355, 1);
            }
        }
    }

    @keyframes cyc {
        0% { transform: scale(.75) rotate(0deg);}
        100% { transform: scale(.75) rotate(360deg);}
    }
}

.fade-enter-active, .fade-leave-active {
  transition: all .25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0;
}

</style>


// WEBPACK FOOTER //
// src/components/ChatLogin.vue